{
  "active": "กำลังใช้งาน",
  "pending_invite": "",
  "deactivated": ""
}
